import { defined } from './defined.js';
import { empty } from './strings.js';
export const urlParams = parseUrlParams();
export function parseUrlParams(search = window.location.search) {
    const items = search
        .slice(search.indexOf('?') + 1)
        .split('&')
        .filter((x) => !!x);
    return items.reduce((params, item) => {
        const [key, val] = item.split('=');
        params[key] = params[key.toLowerCase()] = decodeURIComponent(val);
        return params;
    }, {});
}
const queryStart = '?';
export function redirect(url = empty, search = window.location.search) {
    const [destPath = empty, destParams = empty] = url.split(queryStart);
    const currentParams = search || (destParams ? queryStart : empty);
    window.location.href =
        destPath + currentParams + (search && destParams ? '&' : empty) + destParams;
}
export function toParams(obj) {
    return Object.keys(obj)
        .filter((k) => defined(obj[k]))
        .map((k) => `${k}=${encodeURIComponent(obj[k])}`)
        .join('&');
}
//# sourceMappingURL=url-params.js.map